import { mapState, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { DefaultEmailTemplateType } from "@/enums/DefaultEmailTemplateType";
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import { MailingTypes } from "@/enums/MailingTypes";
import draggable from 'vuedraggable'
import * as firebase from "firebase";
import Loader from "@/components/loader/Loader.vue";
import { getRegionName } from "@/utils/functionsRegion";
import { StaffAccessLevels } from "@/enums/StaffAccessLevels";
import { hasAccess } from "@/utils/accessControl/accessControl";
import { AccessMatrixKeys } from "@/utils/accessControl/accessMatrixKeysEnum";

export default {
  name: "emailTemplates",
  components: {
    draggable,
    ValidationObserver,
    ValidationProvider,
    ConfirmDlg,
    Loader
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: false,
        ghostClass: "ghost"
      };
    },
    ...mapGetters({
      user: "user"
    }),
    ...mapState({
      emailTemplates: state => (state as any).facilityModule.facilityEmailTemplates,
      facilityEmailTemplateTypes: state => (state as any).facilityModule.facilityEmailTemplateTypes,
      staffs: state => (state as any).facilityModule.selectedFacilityUsers,
      familyMembers: state => (state as any).residentModule.familyMembers,
      devices: state => (state as any).devicesModule.devices,
      currentUser: state => (state as any).authModule.user
    }),
    facilityMailingLists() {
      if (this.selectedTemplate.type === DefaultEmailTemplateType.FamilyAppProfileDeletion) {
      return this.$store.state.facilityModule.facilityMailingLists.filter((list) => list.type === MailingTypes.Family || list.type === MailingTypes.Custom || list.type === MailingTypes.PendingFamilyMembers);
      } else {
      return this.$store.state.facilityModule.facilityMailingLists;
      }
    },
    EmailTemplatesTypes() {
      return Object.values(DefaultEmailTemplateType);
    },
    canAdd() {
      return hasAccess(this.currentUser.accessLevel, AccessMatrixKeys.Settings_EmailTemplates_AddNew)
    },
    canSendEmail() {
      return hasAccess(this.currentUser.accessLevel, AccessMatrixKeys.Settings_EmailTemplates_SendEmail)
    },
  },
  data() {
    return {
      search: "",
      dialog: false,
      mailingListDialog: false,
      sendingEmails: false,
      isSendToDevice: false,
      templateType: null,
      emailTemplatesGroupedAll: [],
      emailTemplatesGrouped: [],
      selectedMailingListItems: [],
      MailingTypes: MailingTypes,
      emailTemplatesTypes: Object.values(DefaultEmailTemplateType).map((x) => { return { name: x, isDefault: true } }),
      facilityEmailTemplateTypeList: [],
      selectedTemplate: null,
      template: {
        title: "",
        type: "",
        typeId: "",
        subject: "",
        isEditor: true
      },
      loading: false,
      loadingPage: true
    };
  },
  watch: {
    dialog() {
      if(this.$refs.observer) this.$refs.observer.reset();
    },
    facilityEmailTemplateTypes(types) {
      this.facilityEmailTemplateTypeList = this.emailTemplatesTypes.concat(types);
    },
    async emailTemplates(list){
      if(list){
        this.emailTemplatesGrouped = this.sortByType(list)
        this.emailTemplatesGroupedAll = this.emailTemplatesGrouped.map((x)=> ({...x}));
        this.loading = false
      }
    }
  },
  async mounted() {
    this.loading = true
    this.$store.dispatch("getFacilityEmailTemplateTypes");
    await this.$store.dispatch("getFacilityEmailTemplates");
    this.$store.dispatch("getFacilityMailingLists");
    this.$store.dispatch("getDevices");
    this.$store.dispatch('getFamilyMembers');
    this.loadingPage = false;
  },
  methods: {
    sortByType(list){
      let listCopy = list.map(x=>({...x}))

      listCopy = listCopy.sort(function(a, b){
      if(a.orderIndex < b.orderIndex) { return -1; }
      if(a.orderIndex > b.orderIndex) { return 1; }
      return 0;
   })

     .sort(function(a, b){
        if(a.displayType < b.displayType) { return -1; }
        if(a.displayType > b.displayType) { return 1; }
        return 0;
     })

      .filter(i=> (i.title && i.title.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) || (i.subject && i.subject.indexOf(this.search.toLowerCase()) !== -1))

      const result = []
      listCopy.forEach((t, index)=>{
        if(index == 0 || listCopy[index - 1].displayType != t.displayType){
          result.push({isHeader: true, displayType: t.displayType})
        }
        result.push(t)
      })

      return result
    },
    onTemplateSearch(){
      if(this.search.length){
        this.dragOptions.disabled = true
        this.emailTemplatesGrouped = this.sortByType(this.emailTemplatesGroupedAll)
      }
      else{
        this.emailTemplatesGrouped = this.emailTemplatesGroupedAll
        this.dragOptions.disabled = false
      }
    },
    async changeList(e){

      const replacedTemplate = this.emailTemplatesGroupedAll[e.moved.newIndex]
      const movedTemplate = this.emailTemplatesGrouped.find(x=>x.id === e.moved.element.id)

      if(!replacedTemplate || !movedTemplate) return

      if(replacedTemplate.displayType === movedTemplate.displayType){
          await this.$store.dispatch("changeEmailTemplateOrderIndex", {
            movedTemplateId: movedTemplate.id,
            replacedTemplateId: replacedTemplate.id,
            newIndex: replacedTemplate.orderIndex,
            oldIndex: movedTemplate.orderIndex
          }).then(()=>{
            this.$store.dispatch("getFacilityEmailTemplates");
          })
      }
      else{
        //if moved to another type
        const currentGroupItems = this.emailTemplatesGroupedAll.filter(x=>x.displayType == replacedTemplate.displayType && !x.isHeader)
        const last = currentGroupItems[currentGroupItems.length-1]
        const newOrderIndex = last.orderIndex + 1

        await this.$store.dispatch("updateEmailTemplateByData", {
          id: movedTemplate.id,
          type: replacedTemplate.type || '',
          typeId: replacedTemplate.typeId || '',
          orderIndex: newOrderIndex
        }).then(()=>{
          this.$store.dispatch("getFacilityEmailTemplates");
        })
      }
      console.log('changeList')
    },
    handleClickTemplate(row) {
      this.$router.push("/settings/emailTemplate/" + row.id);
    },
    routeToEmailTypeManager() {
      this.$router.push("/emailTypeManager");
    },
    setEmailTemplateType(item) {
      if (item.id) {
        this.template.typeId = item.id
        this.template.type = ''
      }
      else {
        this.template.type = item.name
        this.template.typeId = ''
      }
    },
    openSendEmailDialog(selected) {
      if (!selected) return

      this.mailingListDialog = true
      this.selectedTemplate = selected
      this.templateType = this.facilityEmailTemplateTypeList.find(x => x.id === selected.typeId)
    },

    async sendEmail(e) {

      if (!this.selectedMailingListItems.length || !this.selectedTemplate) return;

      try {
        this.sendingEmails = true

       await firebase.app().functions(getRegionName())
              .httpsCallable("emails-sendEmailTemplate")({ 
                emailTemplateId: this.selectedTemplate.id,
                templateData: null,
                mailingListIds: this.selectedMailingListItems.map(x=>x.id), 
                isSendDisabledEmailTemplate: true,
                isAutomationTrigger: true
              })
              .then((snap: any) => {
                  this.$toast.open({
                    message: this.$i18n.messages[this.$i18n.locale]['Settings.EmailList.MessagesSentSuccessfully'],
                    type: "success"
                  });
                  this.mailingListDialog = false
                  this.sendingEmails = false
              }).catch((error: any) => {
                this.sendingEmails = false
                this.$toast.open({
                  message: this.$i18n.messages[this.$i18n.locale]['Settings.EmailList.CannotSendMessages'],
                  type: "error"
                });
              console.error(error);
            });

      }
      catch (error) {
        this.sendingEmails = false
        this.$toast.open({
          message: this.$i18n.messages[this.$i18n.locale]['Settings.EmailList.CannotSendMessages'],
          type: "error"
        });
      }
    },

    async submit() {
      this.loading = true;

      await this.$store.dispatch("createEmailTemplate", this.template);

      this.dialog = false;

      this.template.title = "";
      this.template.type = "";
      this.template.subject = "";
      this.template.isEditor = true;

      this.loading = false;
    }
  }
};
